import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import PageHeader, { cardClass, btnPrimary } from '../components/PageHeader';
import { JOB_STATUS_LABELS } from '../utils/statusConstants';

const Dashboard = () => {
  const [stats, setStats] = useState([]);
  const [recentJobs, setRecentJobs] = useState([]);

  useEffect(() => {
    apiFetch('/admin/jobs/stats').then((r) => setStats(r.data || []));
    apiFetch('/admin/jobs').then((r) => setRecentJobs((r.data || []).slice(0, 8)));
  }, []);

  const total = stats.reduce((n, s) => n + s.count, 0);
  const unassigned = recentJobs.filter((j) => !j.assigned_vendor_id && j.status !== 'cancelled' && j.status !== 'closed').length;

  return (
    <div>
      <PageHeader
        title="Dashboard"
        subtitle="Overview of cleaning operations"
        action={
          <Link to="/jobs/new" className={btnPrimary}>
            New job
          </Link>
        }
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className={`${cardClass} p-5`}>
          <p className="text-slate-500 text-sm">Total jobs</p>
          <p className="text-3xl font-semibold text-slate-900 mt-1">{total}</p>
        </div>
        <div className={`${cardClass} p-5`}>
          <p className="text-slate-500 text-sm">Recent (needs vendor)</p>
          <p className="text-3xl font-semibold text-amber-700 mt-1">{unassigned}</p>
        </div>
        <div className={`${cardClass} p-5`}>
          <p className="text-slate-500 text-sm">Statuses tracked</p>
          <p className="text-3xl font-semibold text-slate-900 mt-1">{stats.length}</p>
        </div>
        <div className={`${cardClass} p-5`}>
          <p className="text-slate-500 text-sm">Quick links</p>
          <div className="flex flex-wrap gap-2 mt-2 text-sm">
            <Link to="/accounts" className="text-teal-700 hover:underline">
              Accounts
            </Link>
            <Link to="/vendors" className="text-teal-700 hover:underline">
              Vendors
            </Link>
          </div>
        </div>
      </div>

      {stats.length > 0 && (
        <div className={`${cardClass} p-5 mb-8`}>
          <h2 className="font-medium text-slate-900 mb-3">Jobs by status</h2>
          <div className="flex flex-wrap gap-2">
            {stats.map((s) => (
              <Link
                key={s.status}
                to={`/jobs?status=${s.status}`}
                className="text-sm bg-slate-50 border border-slate-200 px-3 py-1.5 rounded-lg hover:border-teal-300"
              >
                {JOB_STATUS_LABELS[s.status] || s.status}: <strong>{s.count}</strong>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className={cardClass}>
        <div className="px-5 py-4 border-b border-slate-100 flex justify-between items-center">
          <h2 className="font-medium">Recent jobs</h2>
          <Link to="/jobs" className="text-sm text-teal-700 hover:underline">
            View all
          </Link>
        </div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-left">
            <tr>
              <th className="px-5 py-3">Job #</th>
              <th className="px-5 py-3">Account</th>
              <th className="px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {recentJobs.map((j) => (
              <tr key={j.id} className="border-t border-slate-100">
                <td className="px-5 py-3">
                  <Link to={`/jobs/${j.id}`} className="text-teal-700 font-medium">
                    {j.job_number}
                  </Link>
                </td>
                <td className="px-5 py-3">{j.account_name}</td>
                <td className="px-5 py-3">{JOB_STATUS_LABELS[j.status] || j.status}</td>
              </tr>
            ))}
            {recentJobs.length === 0 && (
              <tr>
                <td colSpan={3} className="px-5 py-8 text-center text-slate-500">
                  No jobs yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;
